// Client-side format helpers.
//
// Backend storage / display canonical formats
//   schedule_date : "DD-MM-YYYY"
//   schedule_time : "hh:mm AM/PM"
//
// HTML native <input type="date"> and <input type="time"> use
// "YYYY-MM-DD" and "HH:MM" respectively — these helpers bridge the two
// worlds so the UI can lean on the native pickers while persisting the
// canonical strings.

const DDMMYYYY_RE = /^(\d{2})-(\d{2})-(\d{4})$/;
const YYYYMMDD_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const TIME12_RE = /^(0?[1-9]|1[0-2]):([0-5]\d)\s?([AaPp][Mm])$/;
const TIME24_RE = /^([01]?\d|2[0-3]):([0-5]\d)$/;

export function toDdMmYyyy(value) {
    if (!value) return "";
    const s = String(value).trim();
    if (DDMMYYYY_RE.test(s)) return s;
    const m = YYYYMMDD_RE.exec(s);
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;
    return s;
}

export function toIsoDate(value) {
    if (!value) return "";
    const s = String(value).trim();
    if (YYYYMMDD_RE.test(s)) return s;
    const m = DDMMYYYY_RE.exec(s);
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;
    return "";
}

export function to12h(value) {
    if (!value) return "";
    const s = String(value).trim().toUpperCase();
    if (TIME12_RE.test(s)) {
        const [, hRaw, mm, mer] = TIME12_RE.exec(s);
        return `${String(parseInt(hRaw, 10)).padStart(2, "0")}:${mm} ${mer.toUpperCase()}`;
    }
    const m24 = TIME24_RE.exec(s);
    if (m24) {
        const h = parseInt(m24[1], 10);
        const mer = h < 12 ? "AM" : "PM";
        const h12 = h % 12 || 12;
        return `${String(h12).padStart(2, "0")}:${m24[2]} ${mer}`;
    }
    return "";
}

export function to24h(value) {
    if (!value) return "";
    const s = String(value).trim().toUpperCase();
    const m12 = TIME12_RE.exec(s);
    if (m12) {
        let h = parseInt(m12[1], 10) % 12;
        if (m12[3].toUpperCase() === "PM") h += 12;
        return `${String(h).padStart(2, "0")}:${m12[2]}`;
    }
    if (TIME24_RE.test(s)) {
        const [, hh, mm] = TIME24_RE.exec(s);
        return `${String(parseInt(hh, 10)).padStart(2, "0")}:${mm}`;
    }
    return "";
}
